import { merge } from 'lodash-es';

import {
  SHIPMENT_FORM_GET_OPTIONS_QUERY,
  VALIDATE_SHIPMENT_FORM_FIELD_QUERY,
} from '../../../app/graphql/jobFormQueries';
import { DynamicFormSchemaProvider } from '../../../components/forms/dynamic/dynamicFormSchema';
import {
  QUOTE_FORM_AUTOFILL_QUERY,
  QUOTE_FORM_SCHEMA_QUERY,
} from '../../../app/graphql/quoteFormQueries';

const REQUIRED = { validation: { rules: { required: true } } };
const NOT_REQUIRED = { validation: { rules: { required: false } } };

function overrideQuoteSchema(schema) {
  const contactInfo = {
    address: {
      postalCode: REQUIRED,
      stateProvince: REQUIRED,
    },
    contact: {
      name: NOT_REQUIRED,
      phone: NOT_REQUIRED,
    },
  };

  return merge({}, schema, {
    serviceInformation: {
      dangerousGoods: REQUIRED,
      exceptedQuantity: REQUIRED,
      unNumber: REQUIRED,
    },
    origin: {
      ...contactInfo,
    },
    destination: {
      ...contactInfo,
    },
    packages: {
      maxWeightValidator: {
        validation: {
          rules: [
            {
              type: 'number',
              max: 50,
              message: ' ',
            },
          ],
        },
      },
    },
  });
}

export default function NewQuoteFormSchemaProvider({ account, children }) {
  return (
    <DynamicFormSchemaProvider
      query={QUOTE_FORM_SCHEMA_QUERY}
      optionsQuery={SHIPMENT_FORM_GET_OPTIONS_QUERY} // should be replaced with get options query for quote
      fieldValidationQuery={VALIDATE_SHIPMENT_FORM_FIELD_QUERY} // should be replaced with validate options query for quote
      autofillQuery={QUOTE_FORM_AUTOFILL_QUERY}
      variables={account && { accountNumber: account.number }}
      skip={!account}
      modifySchema={modifySchema => overrideQuoteSchema(modifySchema)}
      queryName="newShipmentAsyncFieldValidation"
      clearCache
    >
      {children}
    </DynamicFormSchemaProvider>
  );
}
